import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, ButtonToolbar, FormControl} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../../../componentsTopsa/inputs/TopInputs";
import moment from 'moment'
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import RozkladService from "../../../rozklad/RozkladService";
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import {TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import vTrasyService from "../../../../trasyConfig/definicjeTras/vTrasyService";
import KierowcyService from "../../../../zasobyConfig/kierowcy/KierowcyService";
import PojazdyService from "../../../../zasobyConfig/pojazdy/PojazdyService";
import TopSelectSlownik from "../../../../../../componentsTopsa/selects/TopSelectSlownik";
import AppConfig from "../../../../../../AppConfig";
import Validator from "../../../../../../utilities/Validator";

export default class ObsadaListaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            data: moment(),
            kursy: [],
            kurs: null,
            pojazd: null,
            kierowca: null,
            przystankiNaTrasie: [],
            przystanekOd: null,
            przystanekDo: null,
            validateMessages: [],
            error_brak_kursow: false,

            typplatnosci:null,
            stawka:0,

            kierowcy: [],
            pojazdy: []

        };
        this.pobierzKursy = this.pobierzKursy.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeDate = this.onChangeDate.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeKurs = this.onChangeKurs.bind(this)
        this.onChangePojazd = this.onChangePojazd.bind(this)
        this.onChangeKierowca = this.onChangeKierowca.bind(this)
        this.onChangePrzystanekOd = this.onChangePrzystanekOd.bind(this)
        this.onChangePrzystanekDo = this.onChangePrzystanekDo.bind(this)
        this.onChangeTypPlatnosci = this.onChangeTypPlatnosci.bind(this)
        this.onChangeStawka = this.onChangeStawka.bind(this)
        this.wyszukajIUstawKurs = this.wyszukajIUstawKurs.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.duplikowanaObsada)) {
            this.setState({
                trasa: this.props.trasy.find(t => t.idTr === this.props.duplikowanaObsada.id_tr),
                data: moment(this.props.duplikowanaObsada.data),
            })
            this.wyszukajIUstawKurs(this.props.duplikowanaObsada)
            this.pobierzPrzystankiNaTrasie(this.props.duplikowanaObsada.id_tr)
        }
    }

    wyszukajIUstawKurs(duplikowanaObsada) {
        let params = 'data=' + duplikowanaObsada.data + '&idTr=' + duplikowanaObsada.id_tr;
        RozkladService.getSzukajRozkladPierwszePrzystanki(0, 999999, params).then(function (response) {
            this.setState({
                kursy: response.data.content,
                kurs: response.data.content.find(k => k.idKu === duplikowanaObsada.id_ku)
            })

            this.onChangeKurs(response.data.content.find(k => k.idKu === duplikowanaObsada.id_ku))
        }.bind(this))
    }

    onChangeDate(e) {
        this.setState({data: e, kurs: null, error_brak_kursow: false})
        if (Boolean(this.state.trasa) && e !== null) {
            this.pobierzKursy(this.state.trasa, e)
        }
    }

    onChangeTrasa(e) {
        this.setState({trasa: e, kurs: null, error_brak_kursow: false})
        if (Boolean(this.state.data) && e !== null) {
            this.pobierzKursy(e, this.state.data)
            this.pobierzPrzystankiNaTrasie(e.idTr)
        }
    }

    onChangeKurs(obj) {
        this.setState({kurs: obj, kierowcy: [], kierowca: null, pojazdy: [], pojazd: null})

        if (Boolean(obj)) {
            KierowcyService.getZajeciKierowcy(obj.idKu).then(function (response) {
                let arr = Array.from(response.data, item => {
                    return {
                        ...item,
                        imieNazwisko: item.imie + ' ' + item.nazwisko
                    }
                })
                this.setState({kierowcy: arr})
                PojazdyService.getPojazdyDostepne(obj.idKu).then(function (res) {
                    let array = Array.from(res.data, i => {
                        return {
                            ...i,
                            informacje: i.marka + ' ' + i.model + ' ' + i.nrRej
                        }
                    })
                    this.setState({
                        pojazdy: array
                    })
                }.bind(this))

            }.bind(this))
        }
    }

    onChangePojazd(e) {
        this.setState({pojazd: e})
    }

    onChangeKierowca(e) {
        this.setState({kierowca: e})
    }

    pobierzKursy(trasa, data) {
        this.setState({error_brak_kursow: false})
        let params = 'data=' + DateAndTimeFormat.formatYYYYMMDD(data) + '&idTr=' + trasa.idTr;

        RozkladService.getSzukajRozkladPierwszePrzystanki(0, 999999, params).then(function (response) {
            this.setState({kursy: response.data.content})
            if (response.data.content.length === 0) {
                this.setState({error_brak_kursow: true})
            }
        }.bind(this))
    }

    onChangePrzystanekOd(e) {
        this.setState({przystanekOd: e})
    }

    onChangePrzystanekDo(e) {
        this.setState({przystanekDo: e})
    }

    pobierzPrzystankiNaTrasie(trasa) {
        vTrasyService.getWszytskiePrzystankiNaTrasie(trasa).then(function (response) {

            let arr = Array.from(response.data, item => {
                return {
                    ...item,
                    info: item.nazMi + ' ' + item.nazPr
                }
            })

            this.setState({
                przystankiNaTrasie: arr,
                przystanekOd: arr[0],
                przystanekDo: arr[arr.length - 1],
            })
        }.bind(this))
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }

    onClickZapisz() {
        this.state.validateMessages = [];
        let poprawne = true;

        if (!Boolean(this.state.data)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono daty')
        }
        if (!Boolean(this.state.trasa)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano trasy')
        }
        if (!Boolean(this.state.kurs)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano kursu')
        }
        if (!Boolean(this.state.kierowca)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano kierowcy')
        }
        if (!Boolean(this.state.pojazd)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano pojazdu')
        }
        if ((this.state.przystanekOd.kol > this.state.przystanekDo.kol)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Wybrano niepoprawną kolejność przystanków')
        }

        if (!Boolean(this.state.typplatnosci)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano typu płatności')
        } else {
            if (this.state.typplatnosci.wartosc == 'EXTRA') {
                if (!Boolean(this.state.stawka)) {
                    poprawne = false;
                    this.dodajDoValidatorMessages('Wybierając typ płatności EXTRA należy uzupełnić stawkę')
                }
                else {
                    if (!Validator.validateIntOrDouble(this.state.stawka)) {
                        poprawne = false;
                        this.dodajDoValidatorMessages('Wartość stawki jest niepoprawna')
                    }
                    if (parseFloat(this.state.stawka) < 0) {
                        poprawne = false;
                        this.dodajDoValidatorMessages('Wartość stawki jest ujemna')
                    }
                }
            }
        }

        if (poprawne) {
            let data = {
                "data": DateAndTimeFormat.formatYYYYMMDD(this.state.data),
                "godz_1p": parseFloat((this.state.kurs.godz).replace(':','.')),
                "idKi": this.state.kierowca.idKi,
                "idKu": this.state.kurs.idKu,
                "idPo": this.state.pojazd.idPo,
                "idTr": this.state.trasa.idTr,
                "nazKi": this.state.kierowca.informacje,
                "nazPo": this.state.pojazd.informacje,
                "trasa": this.state.trasa.nazTr,
                "idPrOd": this.state.przystanekOd.idPr,
                "idPrDo": this.state.przystanekDo.idPr,
                "stawka": Boolean(this.state.typplatnosci) ? Boolean(this.state.typplatnosci.wartosc == 'EXTRA') ? parseFloat(this.state.stawka) : 0 : 0,
                "typPlat": Boolean(this.state.typplatnosci) ? this.state.typplatnosci.wartosc : 'PODSTAWA',
                "status_obsady":1
            }
            this.props.handleClickZapisz(data)
        }
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                          wartosc={option.status}
                                                                                                                          czyMarginesLewy={true}/>
        </div>
    }

    formatSelectKurs(option) {
        return (<div>
            <span style={{marginRight: '5px'}}>nr</span>
            <span className={'label label-ebus-default'}>
            {option.idKu}
            </span>
            <span style={{marginLeft: '5px'}}>
            <span style={{marginRight: '5px'}}>o godz:</span>
                {option.godz}
            </span>
        </div>)
    }

    formatPrzystanekSelect(option) {
        return (<div><span className={'label label-ebus-default'}>{option.nazMi}</span> {option.nazPr}</div>)
    }

    renderPojazdSelect(option) {
        return (
            <div>
                <span>{option.informacje}</span>
                <div className={'pull-right'}>
                    {
                        Boolean(option.status) ?
                            <span style={{fontSize: '12px', color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
                            :
                            <span style={{fontSize: '12px', color: 'firebrick'}}><i className={'fa fa-times'}></i> zajęty</span>

                    }
                </div>
            </div>
        )
    }

    renderKierowcaSelect(option) {
        return <div>
            <span>{option.imieNazwisko}</span>
            <div className={'pull-right'}>
                {
                    (option.status == 1) ?
                        <span style={{fontSize: '12px', color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
                        :
                        <span style={{fontSize: '12px', color: 'firebrick'}}><i className={'fa fa-times'}></i> zajęty</span>
                }
            </div>
        </div>
    }

    onChangeTypPlatnosci(e){
        this.setState({typplatnosci: e})
    }

    onChangeStawka(e){
        this.setState({
            stawka: e.target.value
        })
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div
                        className={'fieldset-label'}>{Boolean(this.props.duplikowanaObsada) ? 'Duplikuj wpis w obsadzie' : 'Dodaj wpis do obsady'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Data
                                </ControlLabel>
                                <TopInputDate onChange={this.onChangeDate} value={this.state.data} horizontal={true}/>
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>
                                    Trasa
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeTrasa}
                                           value={this.state.trasa}
                                           options={this.props.trasy}
                                           valueKey={'idTr'}
                                           labelKey={'nazTr'}
                                           valueRenderer={this.formatTrasaSelect}
                                           optionRenderer={this.formatTrasaSelect}
                                />
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Od przystanku</ControlLabel>
                                <TopSelect onChange={this.onChangePrzystanekOd} value={this.state.przystanekOd}
                                           options={this.state.przystankiNaTrasie} disabled={(this.state.trasa === null)} clearable={false}
                                           valueKey={'idPr'} labelKey={'info'} optionRenderer={this.formatPrzystanekSelect}
                                           valueRenderer={this.formatPrzystanekSelect}
                                />
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Do przystanku</ControlLabel>
                                <TopSelect onChange={this.onChangePrzystanekDo} value={this.state.przystanekDo}
                                           options={this.state.przystankiNaTrasie} disabled={(this.state.trasa === null)} clearable={false}
                                           valueKey={'idPr'} labelKey={'info'} optionRenderer={this.formatPrzystanekSelect}
                                           valueRenderer={this.formatPrzystanekSelect}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Kurs o godzinie
                                </ControlLabel>
                                <TopSelect
                                    onChange={this.onChangeKurs}
                                    value={this.state.kurs}
                                    options={this.state.kursy}
                                    valueKey={'idKu'}
                                    labelKey={'idKu'}
                                    disabled={(!Boolean(this.state.trasa) || !Boolean(this.state.data))}
                                    valueRenderer={this.formatSelectKurs}
                                    optionRenderer={this.formatSelectKurs}
                                />
                                <TopIf isTrue={this.state.error_brak_kursow}>
                                    <div className={'add-label-margin'}></div>
                                    <TopAlertUwaga text={'Proszę sprawdzić czy jest wygenerowany rozkład'}/>
                                </TopIf>
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Kierowca</ControlLabel>
                                <TopSelect onChange={this.onChangeKierowca} value={this.state.kierowca}
                                           options={this.state.kierowcy}
                                           valueKey={'idKi'} labelKey={'imieNazwisko'}
                                           optionRenderer={this.renderKierowcaSelect}
                                           valueRenderer={this.renderKierowcaSelect}
                                           disabled={!Boolean(this.state.kurs)}
                                />
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Pojazd</ControlLabel>
                                <TopSelect onChange={this.onChangePojazd} value={this.state.pojazd}
                                           options={this.state.pojazdy} valueKey={'idPo'}
                                           labelKey={'informacje'} valueRenderer={this.renderPojazdSelect}
                                           optionRenderer={this.renderPojazdSelect}
                                           disabled={!Boolean(this.state.kurs)}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={2}></Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>
                                    Typ płatności <span className={'req'}>*</span>
                                </ControlLabel>
                                <TopSelectSlownik restUrl={AppConfig.HOST_API() + 'slownik/byNazwa/OBSADA_TYP_PLATNOSCI'}
                                                  onChange={this.onChangeTypPlatnosci}
                                                  valueKey={'id'} labelKey={'wartosc'}
                                />
                            </Col>
                            <TopIf isTrue={Boolean(this.state.typplatnosci) ? this.state.typplatnosci.wartosc == 'EXTRA' : false}>
                                <Col xs={12} lg={1}>
                                    <ControlLabel>
                                        Stawka <span className={'req'}>*</span>
                                    </ControlLabel>
                                    <FormControl type={'number'} onChange={this.onChangeStawka}/>
                                </Col>
                            </TopIf>
                    <Col xs={12} lg={4}>
                                <div className={'add-label-margin'}></div>
                                <ButtonToolbar>
                                    <TopButtonCancel onClick={() => {
                                        this.props.handleClickAnuluj()
                                    }}/>
                                    <TopButtonSave onClick={this.onClickZapisz}/>
                                </ButtonToolbar>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validateMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaLista/components/ObsadaListaForm.js